import styled from "styled-components";

export const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  color: var(--Contrast-Brand, #3B495E);
  text-transform: uppercase;
  margin-bottom: 0px;
  line-height: 1.8rem;
`;

export const StyledTextArea = styled.textarea`
  height: auto;
  padding: 12px;
  font-size: 14px;
  line-height: 1.5;
  resize: none;
  transition: all 0.3s;
  background-color: var(--color-contrast-white, #fff);
  border: 1px;
  outline: 0;
  border-radius: 2px;

  box-shadow: inset -1px 0 0 0 var(--color-neutral-300), 
              inset 0 -1px 0 0 var(--color-neutral-300), 
              inset 1px 0 0 0 var(--color-neutral-300), 
              inset 0 2px 0 0 var(--color-action-hover);

  &:focus {
    outline: none;
    box-shadow: inset -1px 0 0 0 var(--color-neutral-300), 
                inset 0 -1px 0 0 var(--color-neutral-300), 
                inset 1px 0 0 0 var(--color-neutral-300), 
                inset 0 2px 0 0 var(--color-action-default);
  }

  &:disabled {
    background-color: var(--color-neutral-200);
    box-shadow: inset 0 2px 0 0 rgb(149 163 183 / 30%) !important;
    cursor: not-allowed;
  }
`;
